exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".right-align[data-v-88a9842e]{text-align:right}", ""]);

// exports
